<template>
  <div id="xmsq" class="publicMain">
    <!-- 选择系统 -->
    <el-row class="text-a-l">
      <div class="float-l">
        <div class="dy-flex align-i-c min-wt-480 mr-30">
          <label style="width: 80px;">{{ $t("xmsq.queryFormsqxt") }}：</label>
          <ButtonBox
            :id="'wscx'"
            :plain="btncolor != 'cx'"
            :buttonData="getArgumentDetail('wscxbtn')"
            @click.native="getXmsqinfo('cx')"
            :uniqueNum="uniqueNum"
            class="ml-10"
          ></ButtonBox>
          <ButtonBox
            :id="'wsbx'"
            :plain="btncolor != 'bx'"
            :buttonData="getArgumentDetail('wsbxbtn')"
            @click.native="getXmsqinfo('bx')"
            :uniqueNum="uniqueNum"
            class="ml-10"
          ></ButtonBox>
          <ButtonBox
            :id="'wssb'"
            :plain="btncolor != 'sb'"
            :buttonData="getArgumentDetail('wssbbtn')"
            @click.native="getXmsqinfo('sb')"
            :uniqueNum="uniqueNum"
            class="ml-10"
          ></ButtonBox>
          <ButtonBox
            :id="'yjkp'"
            :plain="btncolor != 'jp'"
            :buttonData="getArgumentDetail('yjkpbtn')"
            @click.native="getXmsqinfo('jp')"
            :uniqueNum="uniqueNum"
            class="ml-10"
          ></ButtonBox>
        </div>
        <p class="color-r fs-14 ml-80 mt-5">{{ $t("xmsq.systemtip") }}</p>
      </div>
      <div class="float-l">
        <label style="width: 100px;">{{ $t("sqsq.xmfzr") }}：</label>
        <el-input
          v-model="yhbhoryhmc"
          size="small"
          :clearable="true"
          style="width: 40%;"
          :placeholder="$t('sqsq.bhorxm')"
        >
        </el-input>
        <el-button
          size="small"
          class="ml-40"
          type="primary"
          @click="handleIconClick"
          >{{ $t("sqsq.axmfzrcxxm") }}
        </el-button>
        <p
          ref="yhbhoryhmc2"
          style="width: 200px;"
          class="fs-14 ml-100 mt-5"
        ></p>
      </div>
    </el-row>
    <!-- 选择日期和是否控制金额 -->
    <el-row class="my-10">
      <!-- 选择日期 -->
      <el-col :span="rqSpan" class="py-5" style="text-align: left;">
        <span class="">{{ $t("xmsq.queryFormqzrq") }}：</span>
        <el-date-picker
          v-model="value2"
          type="daterange"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          :range-separator="$t('sqsq.to')"
          :start-placeholder="$t('sqsq.qsrq')"
          :end-placeholder="$t('sqsq.jzrq')"
          align="right"
          size="small"
          style="width:335px"
        >
        </el-date-picker>
      </el-col>
      <!-- 是否控制金额 -->
      <el-col :span="jeSpan" class="py-5 ht-42">
        <div class="text-a-l dy-flex align-i-c ht-all">
          <div
            class="mr-30"
            v-if="
              $store.state.sysCs.sfqy_tysqje == '1' &&
                btncolor != 'cx' &&
                btncolor != 'jp'
            "
          >
            <span class="fs-16 color-b">{{ $t("sqsq.sqje") }}：</span>
            <el-input
              v-model="tyBcsqje"
              placeholder="输入金额"
              size="small"
              class="wt-p-70"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
            ></el-input>
          </div>
          <div class="mr-30">
            <el-checkbox v-model="iscqyx" size="large">
              <span class="fs-16 color-b">{{ $t("xmsq.cqyx") }}</span>
            </el-checkbox>
          </div>
          <div class="mr-30" v-if="btncolor != 'cx' && btncolor != 'jp'">
            <el-checkbox v-model="kzjeall" size="large">
              <span class="fs-16 color-b">{{ $t("xmsq.kzsqje") }}</span>
            </el-checkbox>
          </div>
          <div class="mr-30">
            <el-checkbox v-model="ecsqall" size="large">
              <span class="fs-16 color-b">{{ $t("xmsq.ecsq") }}</span>
            </el-checkbox>
          </div>
          <div class="mr-30" v-if="btncolor == 'bx' || btncolor == 'all'">
            <el-checkbox v-model="yeckall" size="large">
              <span class="fs-16 color-b">{{ $t("xmsq.yeck") }}</span>
            </el-checkbox>
          </div>
          <div class="" v-if="btncolor == 'all'">
            <el-checkbox v-model="mxzall" size="large">
              <span class="fs-16 color-b">{{ $t("xmsq.mxck") }}</span>
            </el-checkbox>
          </div>
        </div>
      </el-col>
      <!-- 申请/重置 -->
      <el-col :span="anSpan" class="py-5">
        <el-button size="small" type="primary" @click="sqsqOpertion">{{
          $t("sqsq.sqBtn")
        }}</el-button>
        <el-button size="small" @click="resetSearch('reset')">{{
          $t("sqsq.resetBtn")
        }}</el-button>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-table
        v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
        :data="tableData"
        :key="tableKey"
        border
        stripe
        ref="multipleTable"
        style="width: 100%; font-size: 12px;"
        @cell-click="cellClick"
        :cell-class-name="tableCellClassName"
        @select="checkboxEvent"
        @select-all="selectionAll"
        :header-cell-style="$store.state.headerCellStyle"
        :cell-style="$store.state.cellStyle"
        :max-height="$store.state.screenHeight - 295"
        :row-style="rowStyle"
      >
        <el-table-column
          type="selection"
          width="40"
          key="1"
          align="center"
          header-align="center"
        >
        </el-table-column>
        <el-table-column
          prop="bmmc"
          :label="$t('xmsq.bmmc')"
          width="190px"
          align="left"
          header-align="center"
          v-if="tableColumnShow.bmmc"
        >
          <template slot-scope="scope">
            {{ scope.row.bmbh }} / {{ scope.row.bmmc }}
          </template>
        </el-table-column>
        <el-table-column
          prop="xmsx"
          :label="$t('xmsq.xmsx')"
          align="center"
          header-align="center"
          v-if="tableColumnShow.xmsx"
          :filters="[
            { text: $t('xmsq.public'), value: '2' },
            { text: $t('xmsq.personal'), value: '1' },
          ]"
          :filter-method="filterHandler"
          width="90"
        >
          <template slot-scope="scope">
            {{
              scope.row.xmsx == "1"
                ? $t("xmsq.personal")
                : scope.row.xmsx == "2"
                ? $t("xmsq.public")
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="xmmc"
          :label="$t('xmsq.xmmc')"
          align="left"
          header-align="center"
          v-if="tableColumnShow.xmmc"
        >
          <template #header>
            <p>
              <span class="mr-5">{{ $t("xmsq.xmmc") }}</span>
              <el-input
                v-model="searchPj"
                size="mini"
                :placeholder="$t('xmsq.searchPlaceholder')"
                style="width: 50%;"
              />
            </p>
          </template>
          <template slot-scope="scope">
            ({{ scope.row.xmbh }}) {{ scope.row.xmmc }} -- {{ scope.row.fzr }}
          </template>
        </el-table-column>
        <el-table-column
          prop="isecsq"
          :label="$t('xmsq.ecsq')"
          align="center"
          header-align="center"
          width="80"
          v-if="tableColumnShow.isecsq"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.isecsq"
              v-show="isecsqinp == scope.$index"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-show="isecsqinp != scope.$index">{{
              scope.row.isecsq == "0" ? $t("sqsq.allow") : $t("sqsq.notallow")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="qssj"
          :label="$t('xmsq.qsrq')"
          align="center"
          header-align="center"
          width="95"
          v-if="tableColumnShow.qssj"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.qssj"
              value-format="yyyy-MM-dd"
              v-if="qsrqinp == scope.$index"
              type="date"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
            </el-date-picker>
            <span v-else>{{ scope.row.qssj }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="jzsj"
          :label="$t('xmsq.jzrq')"
          align="center"
          header-align="center"
          width="95"
          v-if="tableColumnShow.jzsj"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.jzsj"
              value-format="yyyy-MM-dd"
              v-if="jzrqinp == scope.$index"
              type="date"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
            </el-date-picker>
            <span v-else>{{ scope.row.jzsj }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="yeck"
          :label="$t('xmsq.yeck')"
          v-if="yeckshow && tableColumnShow.yeck"
          key="yeckshow"
          align="center"
          header-align="center"
          width="80"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.yeck"
              v-show="yeckinp == scope.$index"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
              <el-option
                v-for="item in yeckoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-show="yeckinp != scope.$index">{{
              scope.row.yeck == "0" ? $t("xmsq.shi") : $t("xmsq.fou")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="kzsqje"
          :label="$t('xmsq.kzsqje')"
          v-if="kzsqjeeshow && tableColumnShow.kzsqje"
          align="center"
          header-align="center"
          width="105"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.kzsqje"
              v-show="kzsqjeinp == scope.$index"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
              <el-option
                v-for="item in kzsqjeoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-show="kzsqjeinp != scope.$index">{{
              scope.row.kzsqje == "0" ? $t("xmsq.shi") : $t("xmsq.fou")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sqje"
          :label="$t('sqsq.sqje')"
          v-if="bcsqjeshow && tableColumnShow.sqje"
          key="bcsqjeshow"
          align="center"
          header-align="center"
          width="120"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.sqje"
              v-if="bcsqjeinp == scope.$index"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="loseFcous(scope.$index, scope.row)"
            ></el-input>
            <span v-else>{{ jeFormat(scope.row.sqje, scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="kyye"
          :label="$t('xmsq.kyye')"
          v-if="kyyeshow && tableColumnShow.kyye"
          width="120px"
          key="kyyeshow"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <span>{{ jeFormat(scope.row.kyye) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="ysqje"
          :label="$t('xmsq.ysqje')"
          v-if="ysqjeshow && tableColumnShow.ysqje"
          key="ysqjeshow"
          align="center"
          header-align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="yhfje"
          :label="$t('xmsq.yhfje')"
          v-if="yhfjeshow && tableColumnShow.yhfje"
          key="yhfjeshow"
          align="center"
          header-align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="ye"
          :label="$t('xmsq.ye')"
          v-if="yeshow && tableColumnShow.ye"
          width="120px"
          key="yeshow"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <span>{{ jeFormat(scope.row.ye) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!--选择项目负责人模态框-->
    <xmsqry-dialog
      :title="$t('sqsq.xzxmfzr')"
      :dialogbsqr="dialogbsqr"
      :tableData="ryxxData"
      :uniqueNum="'Y120102-1-2'"
      :cancelText="$t('common.cancelBtn')"
      :confirmText="$t('common.confirmBtn')"
      @confirm="confirm"
      @cancel="cancel"
    >
      <el-row slot="page">
        <!-- 分页组件 -->
        <Pagination
          :currentPage="currentPage"
          :total="total"
          :limit="limit"
          :small="true"
          :pageSizes="$store.state.pageSizes"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          :uniqueNum="uniqueNum"
        />
      </el-row>
    </xmsqry-dialog>
  </div>
</template>

<script>
import * as yhxx from "@/api/yhxx";
import * as sqgl from "@/api/sqglSpecial";
import XmsqryDialog from "@/components/Dialog_xmsq_ry.vue";
import dateFormat from "@/utils/dateFormat";

export default {
  // 授权申请
  name: "applyProjectAuzSpecial",
  components: { XmsqryDialog },
  computed: {
    rqSpan() {
      let w = this.$store.state.screenWidth;
      if (w > 1920) {
        return 8;
      } else if (1920 >= w && w > 1680) {
        return 8;
      } else if (1680 >= w && w > 1440) {
        return 10;
      } else if (1440 >= w) {
        return 24;
      }
    },
    jeSpan() {
      let w = this.$store.state.screenWidth;
      if (w > 1920) {
        return 13;
      } else if (1920 >= w && w > 1680) {
        return 13;
      } else if (1680 >= w && w > 1440) {
        return 11;
      } else if (1440 >= w) {
        return 24;
      }
    },
    anSpan() {
      let w = this.$store.state.screenWidth;
      if (w > 1920) {
        return 3;
      } else if (1920 >= w && w > 1680) {
        return 3;
      } else if (1680 >= w && w > 1440) {
        return 3;
      } else if (1440 >= w) {
        return 24;
      }
    },
  },
  watch: {
    value2: {
      handler: function(newVal, oldVal) {
        this.selectScope.forEach((item) => {
          this.tableData[item.index].qssj = newVal[0];
          this.tableData[item.index].jzsj = newVal[1];
        });
      },
      deep: true, // 开启深度监听
    },
    kzje: {
      handler: function(newVal, oldVal) {
        this.selectScope.forEach((item) => {
          this.tableData[item.index].kzsqje = newVal;
        });
      },
      deep: true, // 开启深度监听
    },
    kzjeall: {
      handler: function(newVal, oldVal) {
        this.multipleSelection.forEach((item) => {
          let data = this.tableData[item.index];
          data.kzsqje = newVal ? "0" : "1";
          data.sqje = newVal
            ? this.tyBcsqje == ""
              ? data.sqje
              : this.tyBcsqje
            : "0";
        });
      },
      deep: true, // 开启深度监听
    },
    tyBcsqje: {
      handler: function(newVal, oldVal) {
        this.multipleSelection.forEach((item) => {
          this.tableData[item.index].sqje = newVal;
        });
      },
      deep: true, // 开启深度监听
    },
    ecsqall: {
      handler: function(newVal, oldVal) {
        this.multipleSelection.forEach((item) => {
          this.tableData[item.index].isecsq = newVal ? "0" : "1";
        });
      },
      deep: true, // 开启深度监听
    },
    yeckall: {
      handler: function(newVal, oldVal) {
        this.multipleSelection.forEach((item) => {
          this.tableData[item.index].yeck = !newVal ? "1" : "0";
        });
      },
      deep: true, // 开启深度监听
    },
    iscqyx: {
      handler: function(newVal, oldVal) {
        if (newVal) {
          const end = new Date("2050-12-31");
          const start = new Date();
          // end.setTime(start.getTime() + 3600 * 1000 * 24 * (365 * 30 + 7));
          this.value2 = [
            dateFormat.format(start, "yyyy-MM-dd"),
            dateFormat.format(end, "yyyy-MM-dd"),
          ];
        } else {
          this.value2 = [];
        }
      },
      dreep: true,
    },
  },
  data() {
    return {
      btncolor: "",
      flg: "0",
      saveflg: "0",
      currentPage: 1,
      limit: this.$store.state.dataDisplayNum,
      total: 0, // 数据量
      currentRow: null,
      yhxx: this.$store.state.yhxx.yhxx,
      dialogbsqr: false,
      tableKey: 0,
      kzje: "",
      system: "",
      sysid: "",
      queryForm: {
        system: "",
        fzrzjh: "",
        xm: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t("xmsq.onemonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.threemonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.sixmonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.cqyx"),
            onClick(picker) {
              const end = new Date("2050-12-31");
              const start = new Date();
              // end.setTime(start.getTime() + 3600 * 1000 * 24 * 365 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      options: [
        {
          value: "0",
          label: this.$t("sqsq.allow"),
        },
        {
          value: "1",
          label: this.$t("sqsq.notallow"),
        },
      ],
      yeckoptions: [
        {
          value: "0",
          label: this.$t("sqsq.shi"),
        },
        {
          value: "1",
          label: this.$t("sqsq.fou"),
        },
      ],
      kzsqjeoptions: [
        {
          value: "0",
          label: this.$t("sqsq.shi"),
        },
        {
          value: "1",
          label: this.$t("sqsq.fou"),
        },
      ],
      yhbhoryhmc: "",
      multipleSelection: [],
      value2: [],
      kzjeall: true,
      yeckall: true,
      ecsqall: true,
      iscqyx: false,
      tyBcsqje: "",
      yeckshow: false,
      kzsqjeeshow: false,
      bcsqjeshow: false,
      ysqjeshow: false,
      kyyeshow: false,
      yhfjeshow: false,
      yeshow: false,
      tableData: [],
      tabLoading: false, // 表格请求数据loading层
      screenHeight: "0",
      ryxxData: [],
      uniqueNum: "Y120107-1-1",
      qsrqinp: -1,
      isecsqinp: -1,
      jzrqinp: -1,
      yeckinp: -1,
      kzsqjeinp: -1,
      bcsqjeinp: -1,
      selectScope: [],
      xmfzr: false,
      searchPj: "",
      activeTableData: [],
      argumentConfig: {
        wscxbtn: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-wcxt",
        },
        wsbxbtn: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-bxxt",
        },
        wssbbtn: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-sbxt",
        },
        yjkpbtn: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-jpxt",
        },
      },
      argumentDetail: {},
      tableColumns: [],
      tableColumnShow: {},
    };
  },
  methods: {
    // 项目授权过滤
    rowStyle(val) {
      let row = val.row;
      if (this.searchPj == "") {
        return;
      } else {
        if (
          row.xmmc.toLowerCase().includes(this.searchPj.toLowerCase()) ||
          row.xmbh.toLowerCase().includes(this.searchPj.toLowerCase())
          // row.bmmc.toLowerCase().includes(this.searchPj.toLowerCase()) ||
          // row.bmbh.toLowerCase().includes(this.searchPj.toLowerCase())
        ) {
          return;
        } else {
          return {
            display: "none",
          };
        }
      }
    },
    // 项目属性筛选方法
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    // 根据项目负责人查询项目
    getXmByFzr() {
      this.tabLoading = true;
      sqgl
        .getXmByFzr(this.queryForm)
        .then((res) => {
          if (res.data.code == "200") {
            res.data.data.forEach((item, index) => {
              item.yeck = "0";
              item.kzsqje = "0";
              item.isecsq = "0";
              item.index = index;
            });
            this.tableData = res.data.data;
          }
          // 分页
          // this.total = res.data.total;
          this.tabLoading = false;
        })
        .catch((error) => {
          this.tabLoading = false;
        });
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.dataPaging(this.activeTableData);
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.currentPage = 1;
      this.limit = val;
      this.dataPaging(this.activeTableData);
    },
    // 被授权人数据分页
    dataPaging(activeTableData) {
      this.ryxxData = [];
      if (activeTableData) {
        this.total = activeTableData.length;
        if (activeTableData.length <= (this.currentPage - 1) * this.limit) {
          this.currentPage = 1;
        }
        let i = (this.currentPage - 1) * this.limit;
        for (
          i;
          i < this.currentPage * this.limit && i < activeTableData.length;
          i++
        ) {
          this.ryxxData.push(activeTableData[i]);
        }
      }
    },
    // 选择人员
    confirm(val) {
      let ryxx;
      this.dialogbsqr = false;
      ryxx = val[0];
      this.queryForm.fzrzjh = val[0].rydm;
      this.queryForm.xm = val[0].xm;
      if (this.saveflg == "1") {
        this.yhbhoryhmc = val[0].xm;
      } else {
        this.yhbhoryhmc = val[0].rydm;
      }
      if (ryxx.rydm == this.yhxx.ygbh) {
        this.$message.error(this.$t("sqsq.wxsq"));
      } else {
        this.xmfzr = true;
        this.getXmByFzr();
      }
      this.flg = this.saveflg;
    },
    // 取消选择人员
    cancel() {
      this.dialogbsqr = false;
    },
    losechange(index, row) {
      if (row.kzsqje == "1" && row.sqje > "0.00") {
        this.tableData[index].sqje = "0";
      }
      if (row.kzsqje == "0" && row.sqje <= "0.00") {
        this.tableData[index].sqje = row.ye;
      }
      this.isecsqinp = -1;
      this.qsrqinp = -1;
      this.jzrqinp = -1;
      this.yeckinp = -1;
      this.kzsqjeinp = -1;
      this.bcsqjeinp = -1;
    },
    loseFcous(index, row) {
      this.isecsqinp = -1;
      this.qsrqinp = -1;
      this.jzrqinp = -1;
      this.yeckinp = -1;
      this.kzsqjeinp = -1;
      this.bcsqjeinp = -1;
    },
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      //注意这里是解构
      //利用单元格的 className 的回调方法，给行列索引赋值
      row.index = rowIndex;
      column.index = columnIndex;
    },
    // 点击单元格方法
    cellClick(row, column, cell, event) {
      let i = row.index;
      if (column.property === "isecsq") {
        this.isecsqinp = i;
        // row.isecsqinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.click();
        });
      } else if (column.property === "qssj") {
        this.qsrqinp = i;
        // row.qsrqinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.focus();
        });
      } else if (column.property === "jzsj") {
        this.jzrqinp = i;
        // row.jzrqinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.focus();
        });
      } else if (column.property === "yeck") {
        this.yeckinp = i;
        // row.yeckinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.click();
        });
      } else if (column.property === "kzsqje") {
        this.kzsqjeinp = i;
        // row.kzsqjeinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.click();
        });
      } else if (column.property === "sqje") {
        this.bcsqjeinp = i;
        // row.bcsqjeinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.focus();
        });
      }
    },
    // 选择表格行方法
    checkboxEvent(scope, row) {
      this.selectScope = scope;
      scope.forEach((item) => {
        if (
          this.value2.length > 0 &&
          this.value2[0] != "" &&
          this.value2[1] != ""
        ) {
          item.qssj = this.value2[0];
          item.jzsj = this.value2[1];
        }
        item.kzsqje = this.kzjeall ? "0" : "1";
        item.isecsq = this.ecsqall ? "0" : "1";
        item.yeck = !this.yeckall ? "1" : "0";
        item.sqje = this.kzjeall
          ? this.tyBcsqje == ""
            ? item.sqje
            : this.tyBcsqje
          : "0";
        if (
          item.bmbh === row.bmbh &&
          item.xmbh === row.xmbh &&
          (this.system === "bx" || this.system === "sb")
        ) {
          row.system = this.system;
          sqgl
            .getXmfzrKyye(row)
            .then((res) => {
              if (res.data.code == "200") {
                row.kyye = res.data.data;
              }
            })
            .catch((err) => {});
        }
      });
      this.multipleSelection = scope;
    },
    // 表格点击全选时方法
    selectionAll(selection) {
      this.multipleSelection = [];
      this.selectScope = selection;
      if (this.value2.length > 0) {
        selection.forEach((item) => {
          if (this.value2[0] != "" && this.value2[1] != "") {
            item.qssj = this.value2[0];
            item.jzsj = this.value2[1];
          }
          if (this.kzje != "") {
            item.kzsqje = this.kzje;
          }
          if (this.system === "bx" || this.system === "sb") {
            item.system = this.system;
            sqgl
              .getXmfzrKyye(item)
              .then((res) => {
                if (res.data.code == "200") {
                  item.kyye = res.data.data;
                }
              })
              .catch((err) => {});
          }
        });
      }
      this.multipleSelection = selection;
    },
    // 切换查询系统
    getXmsqinfo(system) {
      this.system = system;
      this.btncolor = system;
      this.yeckshow = false;
      this.kzsqjeeshow = true;
      this.queryForm.system = system;
      if (system == "cx") {
        this.sysid = "1001";
        this.kzsqjeeshow = false;
        this.ysqjeshow = false;
        this.yhfjeshow = false;
        this.yeshow = false;
        this.bcsqjeshow = false;
        this.kyyeshow = false;
        this.kzje = "1";
      } else if (system == "bx") {
        this.sysid = "1002";
        this.yeckshow = true;
        this.ysqjeshow = true;
        this.yhfjeshow = false;
        this.bcsqjeshow = true;
        this.kyyeshow = true;
        this.yeshow = true;
      } else if (system == "sb") {
        this.sysid = "1003";
        this.ysqjeshow = true;
        this.yhfjeshow = false;
        this.bcsqjeshow = true;
        this.kyyeshow = true;
        this.yeshow = true;
      } else if (system == "jp") {
        this.sysid = "1014";
        this.yeckshow = false;
        this.ysqjeshow = false;
        this.mxckshow = false;
        this.kzsqjeeshow = false;
        this.bcsqjeshow = false;
        this.yeshow = false;
        this.kyyeshow = false;
      }
      this.tableData = [];
      // this.tabLoading = true; // 关闭请求时的loading层
      if (this.yhbhoryhmc != null && this.yhbhoryhmc != "" && this.xmfzr) {
        this.getXmByFzr();
      }
    },
    // 金额格式化
    jeFormat(je, row) {
      if (je == null || je == undefined) {
        je = "0";
      }
      if (je == "") {
        return je;
      }
      let j = this.$comUtils.moneyFormat(je);
      return j;
    },
    // 确认申请操作
    sqsqOpertion() {
      let _this = this;
      let ok = true;
      let ists = true;
      let tsxx = "";
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      if (mm < 10) {
        mm = "0" + mm;
      }
      if (dd < 10) {
        dd = "0" + dd;
      }
      let dqDate = yy + "-" + mm + "-" + dd;
      if (_this.multipleSelection.length == 0) {
        _this.$message.error(_this.$t("sqsq.qxzsqdxm"));
        ok = false;
      } else {
        _this.multipleSelection.forEach((item) => {
          item.system = this.system;
          item.sysid = this.sysid;
          // item.fzr = this.queryForm.xm;
          item.xmsq = "0";
          // 判断起止时间是否填写
          if (item.qssj == "" || item.jzsj == "") {
            tsxx =
              '"(' +
              item.xmbh +
              ")" +
              item.xmmc +
              '"' +
              _this.$t("xmsq.rqtxbwz");
            ok = false;
          } else if (item.qssj < dqDate) {
            tsxx =
              "“（" +
              item.xmbh +
              "）" +
              item.xmmc +
              "”" +
              _this.$t("xmsq.qsrqxydqrq");
            ok = false;
          }
          // 判断起始日期是否早于截止日期
          else if (item.qssj > item.jzsj) {
            tsxx =
              '"(' +
              item.xmbh +
              ")" +
              item.xmmc +
              '"' +
              _this.$t("xmsq.jzrqdyqsrq");
            ok = false;
          }
          // 判断申请金额不能为空
          else if (item.sqje == null || item.sqje == "") {
            tsxx =
              "“（" +
              item.xmbh +
              "）" +
              item.xmmc +
              "”" +
              _this.$t("sqsq.sqjebnwk");
            ok = false;
          }
          // 如控制金额则金额不能为0
          else if (
            this.system != "cx" &&
            this.system != "jp" &&
            item.kzsqje == "0"
          ) {
            let sqje = parseFloat(item.sqje);
            let kyye = parseFloat(item.kyye);
            let ysqje = parseFloat(item.ysqje);
            if (sqje <= 0) {
              tsxx =
                '"(' +
                item.xmbh +
                ")" +
                item.xmmc +
                '"' +
                _this.$t("sqsq.kzjegz");
              ok = false;
            } else if (sqje > kyye) {
              tsxx =
                tsxx +
                "项目(" +
                item.xmbh +
                "/" +
                item.xmmc +
                ")的申请授权金额已超过项目可用余额(" +
                item.kyye +
                ")\n";
              if (this.$store.state.sysCs.sfqy_kyyeyz === "0") {
                ists = false;
              } else {
                ok = false;
              }
            } else if (sqje < ysqje) {
              tsxx =
                tsxx +
                "项目(" +
                item.xmbh +
                "/" +
                item.xmmc +
                ")的申请授权金额小于已授权金额，可能会导致可用余额为负数(" +
                item.kyye +
                ")\n";
              ists = false;
            }
          }
        });
        if (ok) {
          if (ists) {
            _this
              .$confirm(
                _this.$t("sqsq.Confirmauthorization"),
                _this.$t("sqsq.Confirmationinformation"),
                {
                  distinguishCancelAndClose: true,
                  confirmButtonText: _this.$t("common.confirmBtn"),
                  cancelButtonText: _this.$t("common.cancelBtn"),
                }
              )
              .then((res1) => {
                sqgl.toApplyPower(_this.multipleSelection).then((res) => {
                  if (res.data.code == "200") {
                    _this.$message.success(_this.$t("xmsq.CzSuccess"));
                  }
                });
              })
              .catch((action) => {});
          } else {
            _this
              .$confirm(tsxx, "提示", {
                distinguishCancelAndClose: true,
                confirmButtonText: "继续申请",
                cancelButtonText: "取消申请",
                type: "warning",
                center: true,
              })
              .then(() => {
                sqgl.toApplyPower(_this.multipleSelection).then((res) => {
                  if (res.data.code == "200") {
                    _this.$message.success(_this.$t("xmsq.CzSuccess"));
                  }
                });
              })
              .catch(() => {});
          }
        } else {
          _this
            .$confirm(tsxx, "提示", {
              distinguishCancelAndClose: true,
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "error",
              center: true,
            })
            .then(() => {})
            .catch(() => {});
        }
      }
    },
    // 查询项目人员
    handleIconClick() {
      let arr = [];
      this.$refs.yhbhoryhmc2.innerHTML = "";
      if (this.queryForm.system == "") {
        this.$message.error(this.$t("sqsq.sqsqtip"));
      } else if (this.yhbhoryhmc != null && this.yhbhoryhmc != "") {
        if (this.yhbhoryhmc == this.yhxx.ygbh) {
          this.$message.error(this.$t("sqsq.wxsq"));
        } else {
          yhxx.getSysUser({ rydm: this.yhbhoryhmc }).then((res) => {
            let res1 = res.data.data;
            arr = res1.ryxx;
            this.saveflg = res1.flg;
            if (res.data.code == "200") {
              switch (res1.ryxx.length) {
                case 0:
                  this.$message.error(this.$t("xmsq.zbdryxx"));
                  break;
                case 1:
                  this.flg = res1.flg;
                  this.ryxx = arr[0];
                  if (this.flg == "1") {
                    this.$refs.yhbhoryhmc2.innerHTML = arr[0].rydm;
                    this.queryForm.fzrzjh = arr[0].rydm;
                    this.queryForm.xm = arr[0].xm;
                  } else {
                    this.$refs.yhbhoryhmc2.innerHTML = arr[0].xm;
                    this.queryForm.fzrzjh = arr[0].rydm;
                    this.queryForm.xm = arr[0].xm;
                  }
                  this.xmfzr = true;
                  this.getXmByFzr();
                  break;
                default:
                  this.dialogbsqr = true;
                  // this.ryxxData = res1.ryxx;
                  this.activeTableData = res1.ryxx;
                  this.dataPaging(this.activeTableData);
                  break;
              }
            }
          });
        }
      } else {
        this.flg = "0";
      }
    },
    /** 重置操作 */
    resetSearch(typeFlg) {
      this.yhbhoryhmc = "";
      this.$refs.yhbhoryhmc2.innerHTML = "";
      this.value2 = [];
      this.queryForm = {
        system: "",
        fzrzjh: "",
        xm: "",
      };
      this.btncolor = "";
      this.kzje = "";
      this.xmfzr = false;
      this.kzjeall = true;
      this.yeckall = true;
      this.tyBcsqje = "";
      this.ecsqall = true;
      this.iscqyx = false;
    },
    // 获取查询条件信息
    loadQueryConfig() {
      let _this = this;
      let queryInfo = {
        pageId: "Y120107",
      };
      _this.$requestUtil.getXtQueryConfigMy(queryInfo).then((res) => {
        _this.argumentDetail = res;
      });
    },
    /** 获取参数详情 */
    getArgumentDetail(key) {
      return this.$requestUtil.getArgumentDetail(
        this.argumentConfig,
        this.argumentDetail,
        key
      );
    },
    /** 获取页面表格配置信息 */
    getPageTableConfig() {
      this.tabLoading = true;
      let params = {};
      params.pageId = "Y120107";
      params.moduleId = "1";
      params.groupId = "1";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil
        .getXtTableConfig(params)
        .then((tmpResult) => {
          this.tableColumns = tmpResult;
          let shows = {};
          this.tableColumns.forEach((item) => {
            if (item.columnKey != "xzk") {
              shows[item.columnKey] = item.isShow == "1" ? true : false;
            }
          });
          this.tableColumnShow = shows;
          this.tabLoading = false;
        })
        .catch((err) => {
          this.tabLoading = false;
        });
    },
  },
  mounted() {
    // 监听浏览器的宽和高
    this.screenHeight = document.body.clientHeight;
    this.getPageTableConfig();
    this.loadQueryConfig();
    window.addEventListener(
      "resize",
      () => (this.screenHeight = window.innerHeight),
      false
    );
  },
};
</script>

<style lang="scss" scoped>
.btnColor {
  background-color: rgb(64, 158, 255);
  color: white;
}

/* switch按钮样式 */
::v-deep .isWebClass {
  .el-switch__label--left {
    position: relative;
    left: 37px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__core {
    width: 50px !important;
  }

  .el-switch__label--right {
    position: relative;
    right: 37px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }

  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}

::v-deep .isOkClass {
  .el-switch__label--left {
    position: relative;
    left: 52px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__core {
    width: 70px !important;
  }

  .el-switch__label--right {
    position: relative;
    right: 52px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }

  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}
</style>
